// extracted by mini-css-extract-plugin
export default {"homePage":"home_homePage__Y6iE0"};